<template>
  <div class="container">

    <nyTit1 pathUrl="/sanchan2" />
    <Tit/>
    <div class="content">
      <div class="First">
        <div class="title">
          <span class="txt1">三产融合</span>
        </div>
        <div class="First_content">
          <!--第一部分上开始-->
          <div class="First_top">
            <div class="xiao_biao_ti">营养餐链动产业发展</div>
            <div class="First_top_txt">
              <p>{{ txt1 }}</p>
            </div>
          </div>
          <!--第一部分中间开始-->
          <div class="First_middle">
            <div class="xiao_biao_ti">学生情况</div>
            <div class="First_middle_content"><leftPie /></div>
            <div class="First_middle_content1">
              <div
                class="First_middle_content1_left"
                v-for="(item, index) in left_data"
                :key="index"
              >
                <h5>{{ item.name }}{{ item.typ }}</h5>
                <h6>{{ item.fensi }}{{ item.typ }}</h6>
              </div>
            </div>
          </div>
          <!--第一部分下开始-->
          <div class="First_down">
            <div class="xiao_biao_ti">每年消耗食材</div>
            <div class="te_se">
              <div
                class="te_se_jie_gou"
                v-for="(item, index) in left_data2"
                :key="index"
              >
                <img class="imgs" :src="item.img" />

                <span class="di1"> {{ item.typ }}</span>
                <span class="di2"> {{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 第二个开始 -->
      <div class="Third margin-left">
        <div class="titles1">
          <img src="../assets/img/pingpai/v2/dd.png" />
          <span class="txt1">订单直连优质加工企业</span>
        </div>
        <div class="Third_content">
          <div class="Third_content_1">
            <div
              class="Third_content_1_sp"
              v-for="(item, index) in center_data"
              :key="index"
              @click="videoClick(index, 1,item.type)"
            >
              <img class="Third_content_sp_tup" :src="item.img" />
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 第二个结束 -->

      <div class="Fourth margin-left">
        <div class="titles1">
          <img src="../assets/img/pingpai/v2/dd.png" />
          <span class="txt1">订单直连优质种养基地</span>
        </div>
        <div class="Third_content">
          <div class="Third_content_1">
            <div
              class="Third_content_1_sp"
              v-for="(item, index) in center_datas1"
              :key="index"
              @click="videoClick(index, 2,item.type)"
            >
              <img class="Third_content_sp_tup" :src="item.img" />
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
        <!-- <img src="../assets/img/pingpai/v1/3.jpg" alt="" /> -->
      </div>
    </div>
  </div>
  <!-- 弹窗 -->
  <popBg v-if="popShow"
         :title="type == 1 ? center_data[curVideoIndex1].name : center_datas1[curVideoIndex2].name"
         :popShow="popShow"
         @hiddlen="popHiddlen"
         :code="type == 1? center_data[curVideoIndex1].code : center_datas1[curVideoIndex2].code"
  >
    <div style=" width: 100%;height: 100%" v-if="videotype===1">
      <vue3VideoPlay id="video" width="100%" height="100%" title="冰河世纪"
                     :src=" type == 1 ? center_data[curVideoIndex1].options.src : center_datas1[curVideoIndex2].options.src "
                     :type=" type == 1  ? center_data[curVideoIndex1].options.type   : center_datas1[curVideoIndex2].options.type"
                     :autoPlay="true" />

    </div>
    <div style=" width: 100%;height: 100%" v-else>
      <div style=" width: 100%;height: 100%" v-if="state.AccessToken!=''">
        <!--            {{type == 1 ? (center_data[curVideoIndex1].options.src +AccessToken): center_datas1[curVideoIndex2].options.src+AccessToken}}-->
        <iframe  width="100%" height="100%" id="ysOpenDevice" allowfullscreen
                 :src="type == 1 ? (center_data[curVideoIndex1].options.src +state.AccessToken): center_datas1[curVideoIndex2].options.src+state.AccessToken">
        </iframe>
      </div>


    </div>

  </popBg>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import * as THREE from "three";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
  getCurrentInstance,
  inject
} from "vue";

import nyTit1 from '@/components/nyTit1.vue'
import Tit from '@/components/Tit.vue'
import leftPie from "@/components/yingyangcan/left_pie";
import leftbar from "@/components/pingpai/left_bar";
import { useRouter } from "vue-router";
import popBg from "../components/popBg.vue";
import { useStore } from "vuex";
export default {
  name: "Home",
  setup() {
    const router = useRouter();
    // const AccessToken = inject('AccessToken')
    const store = useStore();
    const state = reactive({
      url: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img",
      left_data: [
        {
          typ: "人",
          name: "129375",
          fensi: "享受营养餐学生129375",
        },
        {
          typ: "人",
          name: "80000",
          fensi: "在校就餐学生约80000",
        },
      ],

      left_data2: [
        {
          typ: "面粉",
          name: "4100吨",
          img: require("../assets/img/pingpai/v2/mf.png"),
        },
        {
          typ: "大米",
          name: "3700吨",
          img: require("../assets/img/pingpai/v2/dm.png"),
        },
        {
          typ: "肉类",
          name: "4050吨",
          img: require("../assets/img/pingpai/v2/rl.png"),
        },
        {
          typ: "鸡蛋",
          name: "945吨",
          img: require("../assets/img/pingpai/v2/jd.png"),
        },
        {
          typ: "牛奶",
          name: "3000吨",
          img: require("../assets/img/pingpai/v2/nn.png"),
        },
        {
          typ: "蔬菜",
          name: "4100吨",
          img: require("../assets/img/pingpai/v2/sc.png"),
        },
      ],

      center_data: [
        {
          name: "牛硕奶业",
          type:1,//1是使用VideoPlay播放2是直接嵌套播放

          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/image/3c-2-1.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/3c-2-1.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "上农实业",
          type:1,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/image/3c-2-2.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/3c-2-2.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "久久面粉",
          type:2,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/image/3c-2-3.gif",
          // options: {
          //   src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/jjmf.mp4", //视频源
          //   type: "video/mp4", //视频类型
          // },
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AZ9924584/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"AZ9924584"
        },
        {
          name: "益家康食品 ",
          type:2,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/image/3c-2-4.gif",
          // options: {
          //   src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/yjksp.mp4", //视频源
          //   type: "video/mp4", //视频类型
          // },
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AZ8538420/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"AZ8538420"
        },
        {
          name: "蔡盘子粉条 ",
          type:2,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/image/slf.gif",
          // options: {
          //   src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/slf.mp4", //视频源
          //   type: "video/mp4", //视频类型
          // },
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/FB2501929/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"FB2501929"
        },
        {
          name: "旷华食品 ",
          type:1,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/image/3c-2-5.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/khsp.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
      ],

      center_datas1: [
        {
          name: "黄瓜种植基地 ",
          type:2,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/bazi/bazi/40h.gif",
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/FB2502012/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"FB2502012"
        },
       
        {
          name: "土豆种植基地 ",
          type:2,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/bazi/bazi/15h.gif",
          // options: {
          //   src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/3c-2-12.mp4", //视频源
          //   type: "video/mp4", //视频类型
          // },
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AZ8538386/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"AZ8538386"
        },
        {
          name: "红薯种植基地",
          type:2,//1是使用VideoPlay播放2是直接嵌套播放
          img:require("../assets/img/hongshu.jpg"),
          // img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/image/3c-2-11.gif",
          // options: {
          //   src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/hongshu3.mp4", //视频源
          //   type: "video/mp4", //视频类型
          // },
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/FB1423291/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"FB1423291"
        },
         {
          name: "小岳寺蛋鸡场",
           type:1,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/image/3c-2-10.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/3c-2-10.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        
        {
          name: "牧原猪场",
          type:1,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/image/3c-2-7.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/3c-2-7.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "五龙肉鸡场",
          type:1,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/image/3c-2-8.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/3c-2-8.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        
      ],

      txt1: "全县现有学生235428人，其中享受营养餐学生129375人，在校就餐学生约80000人。为全面守护学生“舌尖上的安全”，上蔡县全面深化学校食堂管理及营养餐供应改革，坚持“上材上用”，整合县内优质农产品和食品产业链，鼓励生产企业依法依规参与营养餐供应招投标，实现了校园食品安全和相关产业的“双赢”。",
      txt2: "农业品质品牌明显提升，被农业农村部认定农业企业品牌1家、区域公用品牌1家、产品品牌8家，名特优新农产品10个，全县认证“三品一标”农产品75家142个，其中“邵店黄姜”“崇礼红薯”“无量寺高青萝卜” 被认定为国家地理标志性农产品。",
      popShow: false,
      curVideoIndex1: 0,
      curVideoIndex2:0,
      isShow: false,
      startVal: 0, //数字结束
      type: 1,
      videotype:1,
      AccessToken:""
    });
    onMounted(() => {
      init();
      animate();
      store.commit('getToken')
      setTimeout(()=>{
        // console.log(store.state.AccessToken)
        // state.AccessToken = store.state.AccessToken
        state.AccessToken = localStorage.getItem('AccessToken')
      },1000)

    });
    onUnmounted(() => {
      // 清理资源
      // renderer.dispose();
    });
    // 弹出视频
    function videoClick(index1, type,types) {
      console.log(index1);
      state.type = type;
      if(state.type==1){
        state.curVideoIndex1 = index1;
      }else {
        state.curVideoIndex2 = index1;
      }
      state.popShow = true;


      state.videotype = types;

    }
    // 关闭弹出
    function popHiddlen() {
      state.popShow = false;
    }

    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });
    // 返回上一页
    function clickReturn() {
      console.log("上一页");
      router.go(-1);
    }
    function close() {
      state.isShow = !state.isShow;
    }
    // 旋转
    function init() {
      // 初始化渲染器
    }
    function animate() {}
    return {
      ...toRefs(state),
      close,
      clickReturn,
      videoClick,
      popHiddlen,
    };
  },
  components: {
    nyTit1,
    leftPie,
    leftbar,
    popBg,
    Tit
  },
};
</script>

<style lang="less" scoped>
a {
  display: block;
  width: 100%;
  height: 100%;
}
.container {
  width: 100%;
  height: 100%;
  background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/data1/bj.jpg")
    no-repeat top center;
  background-size: 100% 100% !important;
  color: #fff;
  position: relative;


  //4个区域内容的标题
  .First .title {
    background: url("../assets/img/shancaixianqing/xq/bt2.png") no-repeat;
  }
  .title {
    width: 100%;
    height: 70px;
    padding-left: 50px;
    box-sizing: border-box;
    line-height: 70px;
    color: #fff;
    background: url("../assets/img/pingpai/v1/2bt.png") no-repeat;
    display: flex;
    span {
      display: block;
    }
    .txt1 {
      font-size: 42px;
      background: linear-gradient(to bottom, #fff 25%, #abdfff 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-style: italic;
      font-weight: bold;
      padding: 0 10px;
    }
  }
  //公共标题区域
  .xiao_biao_ti {
    width: 100%;
    height: 55px;
    background: #072d50;
    font-size: 30px;
    text-align: left;
    display: flex;
    //justify-content: center;
    align-items: center;
    text-indent: 1em;
    margin-top: 15px;
  }

  //右侧公共标题
  .titles1 {
    width: 100%;
    height: 160px;
    display: flex;
    align-items: center;
    img {
      width: 160px;
      height: 160px;
    }
    span {
      font-size: 42px;
      background: linear-gradient(to bottom, #fff 25%, #abdfff 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-style: italic;
      font-weight: bold;
      padding: 0 10px;
      text-indent: 1em;
    }
  }
  // 内容区域
  .content {
    position: absolute;
    top: 220px;
    left: 0;
    width: 100%;

    height: calc(100% - 210px);
    display: flex;
    position: relative;
    padding: 20px 80px 48px;
    box-sizing: border-box;
    .margin-left {
      margin-left: 100px;
      // border: #fff 1px solid;
    }
    .First {
      flex-basis: 13%;
      height: 100%;
      // border: #fff 1px solid;
      margin-left: 25px;
      display: flex;
      flex-direction: column;

      .First_content {
        flex: 1;
        display: flex;
        flex-direction: column;
      }
      .First_top {
        display: flex;
        flex-direction: column;

        width: 100%;
        height: 440px;
        .First_top_txt {
          width: 100%;
          flex: 1;
          padding-top:10px;
          p {
            font-size: 30px;
            line-height: 30px;
            color: #fff;
            line-height: 58px;
            text-align: left;
            text-indent: 2em;
          }
        }
      }
      .First_middle {
        width: 100%;
        height: 470px;
        // flex: 1;
        display: flex;
        flex-direction: column;
        .First_middle_content {
          width: 100%;
          flex: 1;
        }
        .First_middle_content1 {
          width: 100%;
          height: 100px;
          margin: 30px 0;
          display: flex;
          .First_middle_content1_left {
            height: 100%;
            flex: 1;
            background: url("../assets/img/pingpai/v2/xs.png") no-repeat 0% 0%;

            // border: 1px solid #fff;

            h5 {
              background: linear-gradient(to bottom, #ecfffc 25%, #00fcff 100%);
              background-clip: text;
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              // font-style: italic;
              font-weight: bold;
              padding: 0 9px;
              font-size: 40px;
              text-align: left;
              text-indent: 1.7em;
              margin-top: 10px;
            }
            h6 {
              font-size: 26px;
              color: #d6ffff;
              text-align: left;
              text-indent: 3em;
            }
          }
          // .First_middle_content1_right {
          //   height: 100%;
          //   flex: 1;
          // }
        }
      }
      .First_down {
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        .te_se {
          width: 100%;
          flex: 1;
          display: flex;
          flex-wrap: wrap;

          .te_se_jie_gou {
            width: 33.33%;
            height: 50%;
            // border: #fff 1px solid;
            display: flex;
            align-items: center;

            // position: relative;
            .imgs {
              width: 100px;
              height: 100px;
              display: flex;
              // justify-content: center;
            }
            .di1 {
              // width: calc(100% - 110px);

              font-size: 30px;
              // position: absolute;
              // left: 0;
              // top: 37%;
            }
            .di2 {
              // width: calc(100% - 110px);
              font-size: 30px;
              // position: absolute;
            }
          }
        }
      }
    }

    //左边内容的公共样式
    .Third_content {
      width: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      z-index: 1;
      .Third_content_biaoti {
        width: 100%;
        height: 80px;
        background: url("../assets/img/pingpai/v1/jc.png") no-repeat 2px 5px;
        // border: 1px solid #fff;
        font-size: 38px;
        color: #fff;
        text-indent: 2em;
        text-align: left;
        display: flex;
        // justify-content: center;
        align-items: center;
      }
      .Third_content_1 {
        width: 100%;
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        justify-content: space-between;
        padding: 50px 50px;

        .Third_content_1_sp {
          width: 29%;
          height: 45%;
          margin: 2% 2%;

          background: url("../assets/img/pingpai/v2/spk.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;

          .Third_content_sp_tup {
            width: 650px;
            height: 440px;
            margin: 0 5px;
            padding: 7px 5px;
          }
          span {
            width: 100%;
            font-size: 42px;
            height: 60px;
            // background: linear-gradient(to bottom, #fff 25%, #abdfff 100%);
            // background-clip: text;
            // -webkit-background-clip: text;
            // -webkit-text-fill-color: transparent;
            // font-style: italic;
            // font-weight: bold;
            padding: 0 10px;
            line-height: 60px;
            // text-indent: 1em;
            position: absolute;
            color: #fff;
            left: 0%;
            // top: 45%;
            bottom: 2%;
            z-index: 2;
            background: rgba(20, 54, 102, 0.6);
          }
        }
      }
    }

    .Third {
      flex: 1;
      height: 100%;
      position: relative;
      display: flex;
      flex-direction: column;
    }
    .Fourth {
      flex: 1;
      height: 100%;
      position: relative;
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
